// extracted by mini-css-extract-plugin
export default {"advertCardList":"c-a_gE","advertCardList_max6":"c-a_gF"};